export default __webpack_public_path__ + "static/media/Gesture icons_Shake.c40d2306.svg";